module.exports = __webpack_public_path__ + "static/assets/db18366b02c46fdf9033c9a4a13f911b.png";